export var TOOLBAR_ITEM_TYPE;
(function (TOOLBAR_ITEM_TYPE) {
    TOOLBAR_ITEM_TYPE["button"] = "button";
    TOOLBAR_ITEM_TYPE["fillSpace"] = "fillSpace";
    TOOLBAR_ITEM_TYPE["separator"] = "separator";
    TOOLBAR_ITEM_TYPE["text"] = "text";
    TOOLBAR_ITEM_TYPE["customControl"] = "customControl";
})(TOOLBAR_ITEM_TYPE || (TOOLBAR_ITEM_TYPE = {}));
export var TOOLBAR_BUTTON_TYPE_VIEW;
(function (TOOLBAR_BUTTON_TYPE_VIEW) {
    TOOLBAR_BUTTON_TYPE_VIEW["text"] = "text";
    TOOLBAR_BUTTON_TYPE_VIEW["primary"] = "primary";
})(TOOLBAR_BUTTON_TYPE_VIEW || (TOOLBAR_BUTTON_TYPE_VIEW = {}));
export var TOOLBAR_GROUP_TYPE;
(function (TOOLBAR_GROUP_TYPE) {
    TOOLBAR_GROUP_TYPE["splitButton"] = "splitButton";
})(TOOLBAR_GROUP_TYPE || (TOOLBAR_GROUP_TYPE = {}));
export var TOOLBAR_VIEW_TYPE;
(function (TOOLBAR_VIEW_TYPE) {
    TOOLBAR_VIEW_TYPE["default"] = "default";
    TOOLBAR_VIEW_TYPE["spotted"] = "spotted";
})(TOOLBAR_VIEW_TYPE || (TOOLBAR_VIEW_TYPE = {}));
//# sourceMappingURL=types.js.map